import * as React from 'react';
import YouTube from 'react-youtube';
// 'HelloProps' describes the shape of props.
// State is never set so we use the '{}' type.
export class FullscreenYoutube extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const windowHelper = window;
        windowHelper._uxa.push(['setQuery', window.location.search + (window.location.search.indexOf('?') === -1 ? '?' : '&') + `video-popin=${this.props.videoId}`]);
        windowHelper._uxa.push(['trackPageview']);
    }
    render() {
        let width = Math.round(window.innerWidth * .9);
        if (width > 1280)
            width = 1280;
        let height = Math.round(width / 16 * 9);
        return this.props.visible ? React.createElement(React.Fragment, null,
            React.createElement("style", null, `
      .fullscreen-youtube-outer{
        z-index: 10000;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,.8)
      }

      `),
            React.createElement("div", { onClick: () => this.close(), className: "fullscreen-youtube-outer" },
                React.createElement(YouTube, { videoId: this.props.videoId, onEnd: () => this.close(), onReady: this.onReady, opts: { width: width.toString(), height: height.toString() } }))) : React.createElement(React.Fragment, null);
    }
    close() {
        window.vitalLibrary.closeYoutubeVideo();
    }
    onReady(evt) {
        evt.target.playVideo();
    }
}
